export default __webpack_public_path__ + "aa0cbba86aa66f0fdf6b1750947a3eb6.png";